const trim = require('lodash/trim');
const isFinite = require('lodash/isFinite');
const cleaner = require('./number-cleaner');

/* shamelessly taken from caolans-forms validator.js (and he stole from someone else!) */
const EMAIL_REGEX = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);

const PHONE_REGEX = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);

const NAME_REGEX = new RegExp(/^[A-Za-zÀ-ÖØ-öø-ÿ \-']+$/);

const US_ZIP_CODE_REGEX = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/);

module.exports.isValidEmail = (value) => {
  if (EMAIL_REGEX.test(trim(value))) {
    return true;
  }
  return false;
};

module.exports.isValidPhoneNumber = (value) => {
  if (PHONE_REGEX.test(trim(value))) {
    return true;
  }
  return false;
};

module.exports.isValidName = (value) => {
  if (NAME_REGEX.test(trim(value))) {
    return true;
  }
  return false;
};

module.exports.isValidFirstSecondName = (value) => {
  if (NAME_REGEX.test(trim(value)) && value.indexOf(' ') !== -1) {
    return true;
  }
  return false;
};

module.exports.isValidUsZipCode = (value) => US_ZIP_CODE_REGEX.test(trim(value));

module.exports.validateNumberInForm = (locale, min, max, errorInvalid, errorTooLarge, errorTooSmall) => {
  return (form, field, cb) => {
    const value = cleaner.sanitizeNumber(locale, field.value);

    const valueAsFloat = parseFloat(value);

    if (isNaN(valueAsFloat) || !isFinite(valueAsFloat)) {
      return cb(errorInvalid);
    }

    if (max && valueAsFloat > max) {
      return cb(errorTooLarge);
    }

    if (valueAsFloat < min) {
      return cb(errorTooSmall);
    }
    cb();
  };
};
